import axios from 'axios';

import RsaHelper from '@/global-config/request/rsa/rsa-aes-helper'

function checkAuthTokenExclusion(arr, url) {
    return (arr.indexOf(url) != -1);
}

// Function to generate a unique device ID (basic example)
function generateDeviceId() {
    const userAgent = navigator.userAgent;
    const screen = `${window.screen.width}x${window.screen.height}`;
    const colorDepth = window.screen.colorDepth;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Simple hash function (can be replaced with more complex one)
    const hash = btoa(`${userAgent}|${screen}|${colorDepth}|${timezone}`);
    return hash;
}

// Function to get device details
function getDeviceDetails() {
    const userAgent = navigator.userAgent;
    const platform = navigator.userAgentData?.platform || 'Unknown';
    const screen = `${window.screen.width}x${window.screen.height}`;
    const browserLanguage = navigator.language;

    return `${platform}; ${userAgent}; Screen: ${screen}; Language: ${browserLanguage}`;
}

/*exclusion array, add those url to this array for which you dont want to set token in header*/
var exclusion = ['verify-email'];


const MAX_REQUESTS_COUNT = 1
const INTERVAL_MS = 10
let PENDING_REQUESTS = 0


const defaultOptions = {
    // baseURL: "/test.php", // for localhost new
    // baseURL: "/api", // for built new, proxy in same folder
    // baseURL: "https://sdk.vaultspay.com/api/", // for direct proxy url
    baseURL: process.env.VUE_APP_API_BASE_URL, //
    headers: {
        'Content-Type': 'application/json',
        // 'Content-Type': "multipart/form-data",
        // 'Content-Type': "multipart/form-data",
        
    },
     withCredentials: true,
     crossDomain: true
};


// Create instance
var instance = axios.create(defaultOptions);





// Set the AUTH token for any request
instance.interceptors.request.use(function (config) {

    return new Promise((resolve, reject) => {
        setTimeout(()=>{

        },500)
        let interval = setInterval(() => {
            if (PENDING_REQUESTS < MAX_REQUESTS_COUNT ) {
                PENDING_REQUESTS++
                clearInterval(interval)
                /*the token will be added to header for those url which are not found in the exclusion array*/
                if (!checkAuthTokenExclusion(exclusion, config.url)) {


                    // config.headers.common['Access-Control-Allow-Origin'] = '*';
                }

                let uri = config.data.uri

                config.data.application = 'webSdk'
                config.data.applicationVersion = '1.33'
                config.data.deviceId = generateDeviceId();
                config.data.deviceDetail = getDeviceDetails();
                config.data.latitude = ''
                config.data.longitude = ''

                // **** TO ACTIVE ENCRYPTION TOGGLE FROM ENVIRONMENT VARIABLE ****
                if(process.env.VUE_APP_ACTIVATE_ENC == 'true' || process.env.VUE_APP_ACTIVATE_ENC == true){
                    let encryptData =  RsaHelper.encryptRequest(config.data)

                    config.data = {
                        client : encryptData.rsaEncryptedKey,
                        backend : encryptData.aesEncryptedData
                    }
                }

                // config.data.uri = window.btoa(uri)
                resolve(config)
            }
        }, INTERVAL_MS)
    })

});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    // Do something with response data
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)

    return Promise.resolve(response)
    // return response;
}, function (error) {
    // Do something with response error
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.reject(error)
});

export default instance;
